export const devLaunchAuth = {
  enabled: true,
  userId: '',
  //   userId: '2F8E121C-883E-4C4C-8BFF-2AE2CA1E6A3B',
};
